import { render, staticRenderFns } from "./VisualizarLaudoExterno.vue?vue&type=template&id=462b99c9&"
import script from "./VisualizarLaudoExterno.vue?vue&type=script&lang=js&"
export * from "./VisualizarLaudoExterno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports